import { CaptureChunk } from "../domain/types";

export class ReplayEdgeRing {
  private chunks: CaptureChunk[] = [];
  private totalBytes = 0;

  constructor(private readonly windowMs: number) {}

  append(chunk: CaptureChunk): void {
    this.chunks.push(chunk);
    this.totalBytes += chunk.bytes.byteLength;
    this.trim(chunk.endMs - this.windowMs);
  }

  getSnapshot(): CaptureChunk[] {
    return this.chunks.slice();
  }

  getTotalBytes(): number {
    return this.totalBytes;
  }

  clear(): void {
    this.chunks = [];
    this.totalBytes = 0;
  }

  private trim(cutoffMs: number): void {
    while (this.chunks.length > 0 && this.chunks[0].endMs < cutoffMs) {
      const removed = this.chunks.shift();

      if (removed) {
        this.totalBytes = Math.max(0, this.totalBytes - removed.bytes.byteLength);
      }
    }
  }
}
